// extracted by mini-css-extract-plugin
module.exports = {"message":"message_message__2aY5k","error":"message_error__3sZ3a"};